import { routeConfig } from "@/routes/route";
import { Suspense, lazy } from "react";
import { useTranslation } from "react-i18next";
const LazyLoad = (path: string) => {
  const Comp = lazy(() => import("@BZA/" + path));
  return (
    <Suspense fallback={<></>}>
      <Comp />
    </Suspense>
  );
};

export const useCampaignCenterRouterMap = (): routeConfig[] => {
  const { t } = useTranslation();

  return [
    {
      path: "campaignCenter",
      element: LazyLoad("ToolCenter/campaignCenter/index"),
      name: t("Basics.LeftMenu.MaterialCenter"),
      key: "campaignCenter",
      icon: "campaignCenter",
    },
    {
      path: "campaignCenter/createCampaign",
      element: LazyLoad("ToolCenter/campaignCenter/createCampaign"),
      name: t("Basics.LeftMenu.CreateMaterial"),
      editName: t("Basics.LeftMenu.EditMaterial"),
      key: "createCampaign",
      icon: "createCampaign",
      isHidden: true,
      fromPath: "/toolset/campaignCenter",
    },
    {
      path: "campaignCenter/store",
      element: LazyLoad("ToolCenter/campaignCenter/index"),
      name: t("Basics.LeftMenu.AppStore"),
      key: "campaignCenterStore",
      icon: "campaignCenterStore",
      isHidden: true,
    },
    {
      path: "campaignCenter/store/createCampaign",
      element: LazyLoad("ToolCenter/campaignCenter/Store/creativeMaterial"),
      name: t("Basics.LeftMenu.CreateMaterial"),
      // editName: t("Basics.LeftMenu.EditMaterial"),
      key: "storeCreateCampaign",
      icon: "storeCreateCampaign",
      isHidden: true,
      // fromPath: "/toolset/campaignCenter",
    },
  ];
};

// 保留原有的导出以确保向后兼容
export const campaignCenterRouterMap: routeConfig[] = [
  {
    path: "campaignCenter",
    element: LazyLoad("ToolCenter/campaignCenter/index"),
    name: "物料中心",
    key: "campaignCenter",
    icon: "campaignCenter",
  },
  {
    path: "campaignCenter/createCampaign",
    element: LazyLoad("ToolCenter/campaignCenter/createCampaign"),
    name: "新建物料",
    editName: "编辑物料",
    key: "createCampaign",
    icon: "createCampaign",
    isHidden: true,
    fromPath: "/toolset/campaignCenter",
  },
  {
    path: "campaignCenter/store",
    element: LazyLoad("ToolCenter/campaignCenter/index"),
    name: "应用商店",
    key: "campaignCenterStore",
    icon: "campaignCenterStore",
    isHidden: true,
  },
  {
    path: "campaignCenter/store/createCampaign",
    element: LazyLoad("ToolCenter/campaignCenter/Store/creativeMaterial"),
    name: "新建物料",
    // editName: "编辑物料",
    key: "storeCreateCampaign",
    icon: "storeCreateCampaign",
    isHidden: true,
    // fromPath: "/toolset/campaignCenter",
  },
];
